export default "__VITE_ASSET__DJr4Zr1u__"